import { Component } from '@angular/core';
import { GlobalEventServiceService } from '@services/global-event-service.service';
import { isJsObject, unsub } from '@util/utils';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { Subscription } from 'rxjs';

const headerCellCallbackEventname = 'checkbox_header_cell';

let headerCellId = 10;

function getHeaderCellId() {
  headerCellId++;
  return headerCellId;
}
@Component({
  selector: 'app-checkbox-header-cell-renderer',
  //templateUrl: './checkbox-header-cell-renderer.component.html'
  template: `
  <div class="app-checkbox-header-cell">
    <mat-checkbox [checked]="data.checked"(change)="change($event)"></mat-checkbox>
  </div>
  `,
})
export class CheckboxHeaderCellRendererComponent implements IHeaderAngularComp {

  public params!: IHeaderParams;

  eventName = 'select_all';
  headerCellId = 1;
  headerId = 0;
  callbackEventName = headerCellCallbackEventname;

  data: any = {
    checked: false
  };

  eventSub!: Subscription;

  constructor(
    private eventService: GlobalEventServiceService
  ) {
    this.headerCellId = getHeaderCellId();
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.eventSub = this.eventService.listen(this.callbackEventName).subscribe((evt: any) => {
      //console.log('Callback selected', evt);

      if (isJsObject(evt) && isJsObject(evt.data)
        && (evt.data.callbackId === this.headerCellId
          ||
          evt.data.headerId === this.headerId
          )
      ) {
        this.data.checked = evt.data.checked;
      }
    });
  }

  agInit(params: IHeaderParams): void {
    this.params = params;
    const colDef = params.column.getColDef();
    if (colDef.cellRendererParams) {
      if (colDef.cellRendererParams.headerId) {
        this.headerId = colDef.cellRendererParams.headerId;
      }
      if (colDef.cellRendererParams.headerEventName) {
        this.eventName = colDef.cellRendererParams.headerEventName;
      }
      if(colDef.cellRendererParams.callbackEventName) {
        this.callbackEventName=colDef.cellRendererParams.callbackEventName;
      }
      this.data.checked = !!colDef.cellRendererParams.headerChecked;
    }
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.eventSub = unsub(this.eventSub);
  }

  change($event: any) {
    this.eventService.sendEvent(this.eventName, {
      headerId: this.headerId,
      callbackEventName: headerCellCallbackEventname,
      callbackId: this.headerCellId,
      checked: $event.checked
    });
  }

  refresh(params: IHeaderParams) {
    return true;
  }
}
